import React, { useCallback, useState } from 'react';
import { Accordion } from 'rsuite';
import { CalculatedLicense, CalculatedPeriodLicense } from 'src/types/tax';
import { ActivityDetails } from '../TaxConfirm/ActivityDetails/ActivityDetails';

export interface TaxConfirmPeriodAccordionProps {
  period: CalculatedLicense;
}

/** Renders an Accordion for one period's licenses with memoized onSelect. */
export const TaxConfirmPeriodAccordion = React.memo(
  ({ period }: TaxConfirmPeriodAccordionProps) => {
    const [activeKey, setActiveKey] = useState<string>();
    const onAccordionSelect = useCallback(
      (eventKey: string | number | undefined) => {
        const key = eventKey !== undefined ? String(eventKey) : undefined;
        setActiveKey((oldKey) => (oldKey === key ? undefined : key));
      },
      []
    );

    const handleCloseModal = useCallback(() => {
      setActiveKey(undefined);
    }, []);

    return (
      <Accordion
        bordered
        onSelect={onAccordionSelect}
        className="no-border-accordion"
      >
        {period.licenses?.map((license: CalculatedPeriodLicense) => {
          const key = `${period.startDate}_${license.licenseNumber}`;
          const expanded = key === activeKey;

          return (
            <ActivityDetails
              key={key}
              period={period}
              license={license}
              show={expanded}
              onClose={handleCloseModal}
            />
          );
        })}
      </Accordion>
    );
  }
);

TaxConfirmPeriodAccordion.displayName = 'TaxConfirmPeriodAccordion';
